import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: "alertDurationPct" })
export class AlertDurationPctPipe implements PipeTransform {
  public transform(alert: any) {
    const start = new Date(alert.params.time);
    const end = new Date(alert.params.endTime);
    const mins = (end.getTime() - start.getTime()) / 1000 / 60;

    const pct = (mins * 100) / 180;

    // TODO: remove once all old spikes are gone. Goab used to register spikes
    // longer than 3 hours, so they could last days. Now all the spikes are less
    // or equal to 3 hours.
    if (pct > 100) {
      return 100;
    } else {
      return pct;
    }
  }
}
